import { CrudAbstractModel } from "../../crud-abstract/crud-abstract.model";
import { Location } from "../../location/location.model";
import { Rate } from "../rate-type";
import { LocationMapper } from "../../location/location.mapper";
import { RateMapper } from "../rate.mapper";
import { RateFlatRouteMapper } from "./rate-flat-route.mapper";
import { RateFlatRoute } from "./rate-flat-route.type";
import { WeightBracketPrices } from "../../shared/weight-bracket/weight-bracket-prices.model";

export class RatePickupDeliveryRoute extends CrudAbstractModel {
  constructor(
    public id: number,
    public discriminator: string,
    public rate: Rate,
    public zone: number,
    public comment: string,
    public postalCodeMin: string,
    public postalCodeMax: string,
    public distanceMin: number,
    public distanceMax: number,
    public country: string,
    public location: Location,
    public transitTime: number,
    public serviceDays: number,
    public weightBrackets?: WeightBracketPrices,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getDiscriminator(): string {
    return this.discriminator;
  }

  public setId(param: number) {
    this.id = param;
  }

  public getRate(): Rate {
    return this.rate;
  }

  public getRequestParams() {
    return {
      comment: this.comment,
      zone: this.zone,
      postalCodeMin: this.postalCodeMin,
      postalCodeMax: this.postalCodeMax,
      distanceMin: this.distanceMin,
      distanceMax: this.distanceMax,
      country: this.country,
      location: this.location.getId(),
      weightBrackets: this.weightBrackets.getRequestParams(),
      transitTime: this.transitTime,
      serviceDays: this.serviceDays,
    };
  }

  public isValid(): boolean {
    return !!this.location;
  }

  public getClone(): RateFlatRoute {
    return RateFlatRouteMapper.map({
      id: this.getId(),
      discriminator: this.discriminator,
      rate: RateMapper.map(this.rate),
      zone: this.zone,
      comment: this.comment,
      postalCodeMin: this.postalCodeMin,
      postalCodeMax: this.postalCodeMax,
      distanceMin: this.distanceMin,
      distanceMax: this.distanceMax,
      country: this.country,
      location: LocationMapper.map(this.location),
      weightBrackets: this.weightBrackets.getRequestParams(),
      transitTime: this.transitTime,
      serviceDays: this.serviceDays,
    });
  }
}
